// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"688":"badf541d","6527":"67ab562c","9096":"9e784b99","9599":"c132bf7d"}[chunkId] || chunkId) + "." + {"688":"198d03a36879bba7","2113":"210034d17d4b9824","3178":"2fef98e92b91f321","5876":"a2690a0cb1d474c3","6527":"cdb0bd78f3afff0c","9096":"e0f0d2447d5ce42e","9599":"9dea52e5bdf88116"}[chunkId] + ".js";
};